import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'

import lang from '../lang'

export default class extends React.Component {
  state = {}

  constructor(props) {
    super(props)
  }

  componentDidMount() {}

  componentWillReceiveProps(e) {}

  render() {
    let { language, lang } = this.props
    let { canSelectOwner, cancelReward, otherGid, otherDgid } = this.props
    return (
      <div className="reportTitle">
        <div className="title">{lang.reportTitle}</div>
        <div className="content" dangerouslySetInnerHTML={{ __html: lang.reportContent || '' }}></div>
        {/* <div className="cancelAdmin">
          <div>{!canSelectOwner && otherGid > 0 && lang.cancelAdmin.replace('AAA', otherDgid)}</div>
          {!canSelectOwner && otherGid > 0 && (
            <div
              className="btnC"
              onClick={() => {
                cancelReward(otherGid)
              }}
            >
              <img src="/img/app/roomsupport/open.png" />
            </div>
          )}
        </div> */}
        
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomsupport-op/ReportTitle/index.js